export type OutboxDeliveryStatus = 'pending' | 'leased' | 'dead' | 'completed';
export type OutboxMonitorStatus = OutboxDeliveryStatus | 'all';
export interface OutboxSummary {
  pending: number;
  leased: number;
  dead: number;
  completed: number;
  retriedDeliveries: number;
  totalAttempts: number;
  oldestOutstandingAgeSeconds: number | null;
  eventsWithoutConsumers: number;
}
export interface OutboxMonitorItem {
  eventId: string;
  consumerId: string;
  eventType: string;
  position: number;
  createdUtc: string;
  correlationId: string;
  workflowInstanceId?: number | null;
  occurrenceId?: number | null;
  operationKind: 'action-invocation' | 'module-invocation' | 'outbox-event';
  runId?: string | null;
  invocationId?: string | null;
  actionCode?: string | null;
  outcomeCode?: string | null;
  supersedesInvocationId?: string | null;
  status: OutboxDeliveryStatus;
  attemptCount: number;
  totalAttempts: number;
  maxAttempts: number;
  nextAttemptUtc: string;
  leaseUntilUtc?: string | null;
  lastIssueCode?: string | null;
  completedUtc?: string | null;
  eTag: string;
  canRetry: boolean;
  metadataAvailable?: boolean;
  metadataIssueCode?: string | null;
  triggerCode?: string | null;
  triggerVersion?: number | null;
  sourceSystem?: string | null;
  sourceKind?: string | null;
  sourceEventId?: string | null;
  moduleCode?: string | null;
  commandCode?: string | null;
}
export interface OutboxMonitorPage {
  contractVersion: 1;
  items: OutboxMonitorItem[];
  nextCursor: string | null;
  hasMore: boolean;
}
export interface OutboxDeliveryDetail {
  contractVersion: 1;
  delivery: OutboxMonitorItem;
  attempts: {
    attemptId: string;
    attemptNumber: number;
    startedUtc: string;
    leaseUntilUtc: string;
    status: string;
    finishedUtc?: string | null;
    issueCode?: string | null;
  }[];
  legacyAttemptCount: number;
  recoveries: {
    id: string;
    kind: 'retry-invocation';
    actorUserId: number;
    reason: string;
    occurredUtc: string;
    previousAttempts: number;
  }[];
  newEvaluation: { supported: false; reasonCode: string };
  historyTruncated?: boolean;
}
export interface OutboxWorkerState {
  workerId: 'event-outbox';
  installationDispatchEnabled: boolean;
  paused: boolean;
  effectiveDispatchEnabled: boolean;
  revision: number;
  eTag: string;
  updatedUtc?: string | null;
  updatedByUserId?: number | null;
  lastReason?: string | null;
}
export interface OutboxWorkerUpdate {
  expectedRevision: number;
  paused: boolean;
  reason: string;
}
export interface OutboxReplayRequest {
  reason: string;
  expectedTotalAttempts: number;
}
export const deliveryIdentity = (
  item: Pick<OutboxMonitorItem, 'eventId' | 'consumerId'>,
): string => JSON.stringify([item.eventId, item.consumerId]);

export interface OutboxWorkerAudit {
  id: string;
  workerId: 'event-outbox';
  revision: number;
  action: 'pause' | 'resume';
  actorUserId: number;
  reason: string;
  occurredUtc: string;
}
